import { createConfig, http } from 'wagmi';
import { bsc, bscTestnet, hardhat } from 'wagmi/chains';
import { coinbaseWallet, injected, walletConnect } from 'wagmi/connectors';

// WalletConnect Cloud project id — lets mobile users in a normal browser pick
// any installed wallet app via QR / deep link (injected wallets don't exist in
// a regular mobile browser, only inside a wallet's in-app browser).
// Sourced from VITE_WALLETCONNECT_ID (see .env.development / .env.production).
const WALLETCONNECT_PROJECT_ID = import.meta.env.VITE_WALLETCONNECT_ID as string;

// Resolve the target chain from VITE_TARGET_CHAIN: bscTestnet | bsc | hardhat.
// Defaults to BSC testnet when the var is missing or unrecognized.
const CHAINS_BY_NAME = { bscTestnet, bsc, hardhat } as const;
const targetChainName = import.meta.env.VITE_TARGET_CHAIN as keyof typeof CHAINS_BY_NAME | undefined;

const APP_METADATA = {
  name: 'Pelagos DEX',
  description: 'Pelagos DEX — Salt concentration & infinite DeFi flow',
  url: 'https://pelagos-dex.web.app',
  icons: ['https://pelagos-dex.web.app/favicon.png'],
};

export const wagmiConfig = createConfig({
  chains: [bscTestnet, hardhat, bsc],
  // shimDisconnect forces a `wallet_requestPermissions` call on every fresh
  // connect (to re-prompt account selection), but that call throws a bogus
  // "wallet must has at least one account" error on some MetaMask versions.
  // Disabling it falls back to plain `eth_requestAccounts`, which works.
  connectors: [
    injected({ shimDisconnect: false }),
    walletConnect({ projectId: WALLETCONNECT_PROJECT_ID, metadata: APP_METADATA, showQrModal: true }),
    coinbaseWallet({ appName: APP_METADATA.name, appLogoUrl: APP_METADATA.icons[0] }),
  ],
  transports: {
    [bscTestnet.id]: http(),
    [hardhat.id]: http('http://127.0.0.1:8545'),
    [bsc.id]: http(),
  },
});

// live deployment lives on BSC testnet (see contracts/scripts/deploy.ts);
// the local Hardhat node (chain 31337) is still available for offline dev/testing
export const TARGET_CHAIN = (targetChainName && CHAINS_BY_NAME[targetChainName]) || bscTestnet;

// UI 표기용 짧은 체인 이름. "Switch to BSC"처럼 애매하게 쓰면 사용자가
// BSC 메인넷(56)으로 수동 전환해 버려 배너가 계속 남는 사고가 난다.
export const TARGET_CHAIN_LABEL: string =
  (TARGET_CHAIN.id as number) === bsc.id ? 'BSC' : 'BSC Testnet';
